import type {
  GetChangeBuildTypesApiArg,
  GetChangeDeploymentConfigurationsApiArg,
} from '../../../../services/rest'

export const getChangeBuildTypesArg = (changeLocator: string): GetChangeBuildTypesApiArg => ({
  changeLocator,
  fields: 'buildType(id,type)',
})

export const getChangeDeploymentsArg = (
  changeLocator: string,
): GetChangeDeploymentConfigurationsApiArg => ({changeLocator, fields: 'buildType(id)'})
